module.exports = __webpack_public_path__ + "img/playstore.fc123e11.png";